export default defineNuxtPlugin(() => {
  if (!['production', 'staging'].includes(process.env.NODE_ENV)) {
    return;
  }

  function loadScript() {
    window.removeEventListener('touchstart', loadScript);
    window.removeEventListener('mousemove', loadScript);
    window.removeEventListener('scroll', loadScript);

    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js'
    );
    create();
  }

  function create() {
    window.fbq('init', '654867001874229');
    window.fbq('track', 'PageView');
    const router = useRouter();

    router.afterEach(() => {
      window.fbq('track', 'PageView');
    });
  }

  window.addEventListener('touchstart', loadScript);
  window.addEventListener('mousemove', loadScript);
  window.addEventListener('scroll', loadScript);
});
